import React from 'react'
import PropTypes from 'prop-types'
import Link from './Link'
import clsx from 'clsx'
import ArrowRightIcon from '../Icons/ArrowRightIcon'

const linkClassNames = (className, variant) =>
  clsx(
    `button md:font-medium font-light px-5 py-2 border border-brand-primary rounded-full
    transition duration-500 `,
    {
      'text-brand-primary hover:text-black hover:bg-brand-primary':
        variant === 'primary',
      'bg-brand-primary text-black hover:text-brand-primary hover:bg-black':
        variant === 'secondary'
    },
    className
  )

const TgcLink = ({ children, href, className, variant }) => (
  <Link
    className={linkClassNames(className, variant)}
    href={href}
  >
    {children}
    <ArrowRightIcon className='inline w-4 ml-2 -rotate-45' />
  </Link>
)

export default TgcLink

TgcLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary'])
}

TgcLink.defaultProps = {
  children: '',
  href: '/',
  className: '',
  variant: 'primary'
}
